(function () {
  function money(value) {
    if (value == null || !Number.isFinite(Number(value))) return null;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(value));
  }

  function init(root) {
    var apiUrl = root.getAttribute('data-api-url');
    if (!apiUrl) return;

    var mode = 'std';
    var expanded = false;
    var items = [];
    var statusEl = root.querySelector('[data-ti-status]');
    var bodyEl = root.querySelector('[data-ti-body]');
    var priceHeader = root.querySelector('[data-ti-price-header]');
    var vipNote = root.querySelector('[data-ti-vip-note]');
    var searchInput = root.querySelector('[data-ti-search]');
    var expandWrap = root.querySelector('[data-ti-expand]');
    var expandBtn = root.querySelector('[data-ti-expand-btn]');
    var stdTab = root.querySelector('[data-ti-tab="std"]');
    var vipTab = root.querySelector('[data-ti-tab="vip"]');

    function filtered() {
      var q = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
      if (!q) return items;
      return items.filter(function (item) {
        return (
          (item.name || '').toLowerCase().indexOf(q) !== -1 ||
          (item.sku || '').toLowerCase().indexOf(q) !== -1
        );
      });
    }

    function render() {
      if (!bodyEl) return;
      var list = filtered();
      var q = (searchInput && searchInput.value ? searchInput.value : '').trim();
      var showCount = q || expanded ? list.length : Math.min(8, list.length);

      if (expandWrap) {
        expandWrap.hidden = !!q || list.length <= 8;
      }
      if (expandBtn) {
        expandBtn.textContent = expanded ? 'Show less' : 'View all models';
      }
      if (priceHeader) {
        priceHeader.textContent = mode === 'vip' ? 'VIP value' : 'Trade-in value';
      }
      if (vipNote) {
        vipNote.setAttribute('data-visible', mode === 'vip' ? 'true' : 'false');
      }
      if (stdTab) stdTab.setAttribute('aria-selected', mode === 'std' ? 'true' : 'false');
      if (vipTab) vipTab.setAttribute('aria-selected', mode === 'vip' ? 'true' : 'false');

      bodyEl.innerHTML = '';
      if (!list.length) {
        var empty = document.createElement('tr');
        empty.innerHTML =
          '<td colspan="2" class="d1-ti__empty">No matching models. Try another search or visit us in-store.</td>';
        bodyEl.appendChild(empty);
        return;
      }

      for (var i = 0; i < showCount; i++) {
        var item = list[i];
        var row = document.createElement('tr');
        var priceLabel;
        var priceClass = 'd1-ti__price';
        if (mode === 'vip') {
          var vipMoney = money(item.vipValue);
          priceLabel = vipMoney ? 'Up to ' + vipMoney : 'Visit in-store';
          priceClass += ' d1-ti__price--vip';
        } else {
          var stdMoney = money(item.tradeInValue);
          priceLabel = stdMoney ? 'Up to ' + stdMoney : 'Visit in-store';
        }
        row.innerHTML =
          '<td><span class="d1-ti__name"></span>' +
          (item.sku ? '<span class="d1-ti__sku"></span>' : '') +
          '</td><td class="' +
          priceClass +
          '"></td>';
        row.querySelector('.d1-ti__name').textContent = item.name;
        var skuEl = row.querySelector('.d1-ti__sku');
        if (skuEl) skuEl.textContent = item.sku;
        row.querySelector('td:last-child').textContent = priceLabel;
        bodyEl.appendChild(row);
      }
    }

    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';

    function setStatus(text, withContactLink) {
      if (!statusEl) return;
      if (!text) {
        statusEl.textContent = '';
        return;
      }
      if (withContactLink) {
        statusEl.textContent = '';
        statusEl.appendChild(document.createTextNode(text + ' '));
        var link = document.createElement('a');
        link.href = contactUrl;
        link.textContent = 'Contact us';
        statusEl.appendChild(link);
        statusEl.appendChild(document.createTextNode('.'));
        return;
      }
      statusEl.textContent = text;
    }

    if (stdTab) {
      stdTab.addEventListener('click', function () {
        mode = 'std';
        render();
      });
    }
    if (vipTab) {
      vipTab.addEventListener('click', function () {
        mode = 'vip';
        render();
      });
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        expanded = false;
        render();
      });
    }
    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    setStatus('Loading trade-in values…');
    fetch(apiUrl, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        var data = payload && payload.data ? payload.data : payload;
        items = Array.isArray(data && data.items) ? data.items : [];
        setStatus('');
        render();
      })
      .catch(function () {
        setStatus('Unable to load live trade-in values right now.', true);
        items = [];
        render();
      });
  }

  document.querySelectorAll('[data-d1-trade-in]').forEach(init);
})();
